import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import CreateNachricht from '../../../../components/ui-component/nachrichten/CreateNachricht';
import NoDetailsInfo from '../../../../components/ui-component/no-details-info/NoDetailsInfo';
import { useFetchNachrichtenDetails } from '../../../../hooks/FetchNachrichten';
import { PAGES_URLS } from '../../../../lib/constants/routes';

// import schemas
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import NachrichtSchema from '../../../../lib/paths/nachricht_FULL_Paths.json';
let P = NachrichtSchema.attributes;

const NachrichtenDetails: FC<{}> = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const numericId = get(location, 'state.id');

	const { loading, data, error } = useFetchNachrichtenDetails(numericId);
	const [openMessage, setOpenMessage] = useState(false);

	const RenderAppLink: FC<{}> = () => {
		const antragID = get(data, `${P.Foerderantrag.path}.id`);
		const maID = get(data, `${P.Mittelabruf.path}.id`);
		const vnID = get(data, `${P.Verwendungsnachweis.path}.id`);
		const znID = get(data, `${P.Zwischenbericht.path}.id`);
		const abID = get(data, `${P.Abschlussbericht.path}.id`);

		// TODO: Bei MA, VN, ZN, AB muss die Pfad repariert werden. ZurZeit wird es zu Allgemein Nr. gezeigt. Dies soll geändert werden zu Eingangsnummer. (Model neue export erforderlich)
		if (!maID && !vnID && !znID && !abID && antragID) {
			const projektNummer = get(data, P.Foerderantrag.schema.attributes.Allgemein_HA_Projekt_Nr.path, '');
			const hasProjektNummer = Boolean(projektNummer);
			const nummerLabel = hasProjektNummer ? 'Projektnummer:' : 'Eingangsnummer:';
			const nummerWert = hasProjektNummer ? projektNummer : get(data, P.Foerderantrag.schema.attributes.Allgemein_Eingangsnummer.path, '');

			return (
				<Typography>
					{nummerLabel}{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`${PAGES_URLS.FoerderDashboard}`, {
								state: {
									id:
										get(data, `${P.Foerderantrag.schema.attributes.Skizze.path}.id`) ?
											get(data, `${P.Foerderantrag.schema.attributes.Skizze.path}.id`)
										:	get(data, `${P.Foerderantrag.path}.id`),
									antragsformular: get(data, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path),
								},
							});
						}}
					>
						{nummerWert}
						{' - '}
						{get(data, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					</Link>
				</Typography>
			);
		} else if (maID) {
			return (
				<Typography>
					Mittelabruf:{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`${PAGES_URLS.FoerderDashboard}`, {
								state: {
									id: get(data, `${P.Foerderantrag.path}.id`),
									antragsformular: get(data, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path),
								},
							});
						}}
					>
						{get(data, P.Mittelabruf.schema.attributes.Allgemein_Eingangsnummer.path, '')}
						{' - '}
						{get(data, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					</Link>
				</Typography>
			);
		} else if (vnID) {
			return (
				<Typography>
					Verwendungsnachweis:{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`${PAGES_URLS.FoerderDashboard}`, {
								state: {
									id: get(data, `${P.Foerderantrag.path}.id`),
									antragsformular: get(data, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path),
								},
							});
						}}
					>
						{get(data, P.Verwendungsnachweis.schema.attributes.Allgemein_Eingangsnummer.path, '')}
						{' - '}
						{get(data, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					</Link>
				</Typography>
			);
		} else if (znID) {
			return (
				<Typography>
					Zwischenbericht:{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`${PAGES_URLS.FoerderDashboard}`, {
								state: {
									id: get(data, `${P.Foerderantrag.path}.id`),
									antragsformular: get(data, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path),
								},
							});
						}}
					>
						{get(data, P.Zwischenbericht.schema.attributes.Allgemein_Eingangsnummer.path, '')}
						{' - '}
						{get(data, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					</Link>
				</Typography>
			);
		} else if (abID) {
			return (
				<Typography>
					Abschlussbericht:{' '}
					<Link
						sx={{ cursor: 'pointer', textDecoration: 'unterlinde' }}
						onClick={() => {
							navigate(`${PAGES_URLS.FoerderDashboard}`, {
								state: {
									id: get(data, `${P.Foerderantrag.path}.id`),
									antragsformular: get(data, P.Foerderantrag.schema.attributes.Allgemein_Antragsformular.path),
								},
							});
						}}
					>
						{get(data, P.Abschlussbericht.schema.attributes.Allgemein_Eingangsnummer.path, '')}
						{' - '}
						{get(data, P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')}
					</Link>
				</Typography>
			);
		} else {
			return <></>;
		}
	};

	if (!numericId) return <NoDetailsInfo title='Nachricht' goBackUrl={PAGES_URLS.Nachrichten} />;
	if (error) console.error(' error', error);
	if (loading) return <LoadingBackdrop />;
	const showAntwortenButton = get(data, P.Allgemein_Ordner.path) === 'Posteingang' && get(data, P.Foerderantrag.path, null) !== null;

	return (
		<>
			<Container>
				<CreateNachricht
					showNachrichtDialog={openMessage}
					handleCloseDialog={() => setOpenMessage(false)}
					applications={[get(data, P.Foerderantrag.path)]}
					isReply={true}
					nachrichtId={get(data, 'id')}
					originalTitle={get(data, P.Allgemein_Betreff.path)}
					originalContent={get(data, P.Allgemein_Inhalt.path)}
				/>
				<Stack spacing={3}>
					<Stack direction={'row'} justifyContent={'space-between'}>
						<Button variant={'outlined'} startIcon={<ArrowBack />} onClick={() => navigate(PAGES_URLS.Nachrichten)}>
							{' '}
							Zurück zu meinen Nachrichten
						</Button>
						{showAntwortenButton && <Button onClick={() => setOpenMessage(true)}>Antworten</Button>}
					</Stack>
					<Stack spacing={3}>
						{' '}
						<Typography variant='h3' component='h2'>
							{'Betreff: ' + get(data, P.Allgemein_Betreff.path)}
						</Typography>
						<Box>
							{get(data, P.Allgemein_Ordner.path) === 'Posteingang' ?
								<Typography>Von: Innovationsförderung Hessen </Typography>
							:	<Typography>
									Von: {get(data, P.Antragsteller.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}{' '}
								</Typography>
							}

							<RenderAppLink />
						</Box>
						<Divider />
						<MarkdownRenderer markdown={get(data, P.Allgemein_Inhalt.path, '')} />
					</Stack>
				</Stack>
			</Container>
		</>
	);
};
export default NachrichtenDetails;
